var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c(_vm.view,_vm._b({tag:"component",on:{"emitEvent":_vm.eventEmitter}},'component',{ ..._vm.$data, view: _vm.view },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }